import { Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { BD_CASES, IMAGES } from "./content";
import { useInView } from "./useInView";

export const BandeDessinee = () => {
  const [ref, cls] = useInView(0.1);
  return (
    <section id="bd" ref={ref} className={`bg-mm-alt text-mm-ink py-24 md:py-32 ${cls}`} data-testid="bd-section">
      <div className="max-w-6xl mx-auto px-6">
        <p className="mm-lab text-mm-golddark">La bande dessinée</p>
        <h2 className="disp mm-h2 mt-4">Une leçon de vie en huit cases</h2>
        <Dialog>
          <DialogTrigger asChild>
            <button type="button" data-testid="bd-open-btn" className="reveal group relative block w-full mt-12 overflow-hidden bg-mm-sand">
              <img src={IMAGES.bd} alt="Bande dessinée : une leçon de vie en huit cases" className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-700" loading="lazy" />
              <span className="absolute bottom-4 right-4 inline-flex items-center gap-2 bg-mm-ink text-mm-paper px-4 py-2 text-sm font-bold">
                <Maximize2 className="w-4 h-4" /> Lire en grand
              </span>
            </button>
          </DialogTrigger>
          <DialogContent className="max-w-[95vw] w-[1400px] p-2 bg-mm-paper rounded-none max-h-[95vh] overflow-auto" data-testid="bd-dialog">
            <DialogTitle className="sr-only">Une leçon de vie en huit cases</DialogTitle>
            <img src={IMAGES.bd} alt="Bande dessinée en grand format" className="w-full h-auto" />
          </DialogContent>
        </Dialog>
        <ol className="st grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-6 mt-12">
          {BD_CASES.map((c, i) => (
            <li key={c} className="border-t-2 border-mm-ink pt-3 text-sm" data-testid={`bd-case-${i + 1}`}>
              <span className="disp text-3xl text-mm-red block">{i + 1}</span>{c}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
